import { action, computed, observable, runInAction } from "mobx";
import { createViewModel } from "mobx-utils";
import * as moment from "moment";
import { api } from "../../api";
import { IEmpresa, IHistoricoNotas, IImportInfo, IManifestacaoCalc, newIImportInfo } from "../../model";
import { IFilter } from "../../model";
import socket from "../../socket";
import { toast } from "react-toastify";
import { sortBy } from "../../utils";
import { NFesStore } from "../nfe/NFesStore";
import Cookies from 'universal-cookie';
const cookies = new Cookies()

export class _ManifestacoesStore {
  obs = observable({
    loaded: false as boolean,
    confirmando: false as boolean,
    statusManifestacao: "" as string,
    imps: [] as IHistoricoNotas[],
    filter: "" as string,
    hora: "" as string,
    confirmadas: "" as string,
    nao_realizadas: "" as string,
    desconhecidas: "" as string,
    ciencia: "" as string,
    currentPage: 1 as number,
    totalErros: 0 as number,
    progressDownload: false as boolean,
    empresas: [] as IEmpresa[],
    InfoDownload: false as boolean,
    InfoDownloadDanfe: false as boolean,
    pdfName: "" as string,
    InfoDownload1: "" as string,
    InfoDownload2: "" as string,
    InfoDownload3: "" as string,
    buscando: false as boolean,
    calcularItems: [] as any[],
    tasks_manifestacoes: [] as any[],
    length_tasks_manifestacoes: 0 as number,
    itens_calculando: [] as string[],
    manifestacoes_summary: newIImportInfo() as IImportInfo,
    isValida: false as boolean,
    erros_manifestacoes: [] as any[],
    avisos_manifestacoes: [] as any[],
  })


  constructor() {
    let channel = socket.channel(`model:historico_notas`);

    channel.join()
      .receive("ok", resp => {
        console.log("Bem vindo6", resp)
      })
      .receive("error", resp => {
        console.log("Error", resp)
      });

    // channel.on("progresso", this.handleEndEndpoint);
    // channel.on("end_progresso", this.handleEndEndpoint);
    // channel.on("confirmando", this.handleEndEndpoint);
    // channel.on("desconhecendo", this.handleEndEndpoint);
    // channel.on("nao_realizado", this.handleEndEndpoint);
    // channel.on("download", this.handleEndEndpoint);
  }

  @action
  async loadEmpresas(): Promise<void> {
    try {
      let resp = await api.get(`/api/empresas-usuario`);
      this.obs.empresas = [];
      this.obs.empresas = resp.data
      this.obs.loaded = true;
    } catch (ex) {
      toast.error(`Erro ao carregar Empresas Usuario, tente novamente mais tarde.`, {});
    }
  }

  @computed
  get sortedEmpresas(): IEmpresa[] {
    return sortBy(this.obs.empresas, "razao_social");
  }

  async buscaDanfe(chave: string, filtro: IFilter): Promise<void> {
    this.obs.buscando = true;

    let filtro_ = {
      ...filtro,
    };

    try {

      let resp = await api.post("/api/danfe-download", filtro_);

      if (resp.data.base64) {

        let linkSource = `data:application/pdf;base64,${resp.data.base64}`
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = chave + ".pdf";
        downloadLink.click();

      }

    } catch (e) {

      toast.error('Erro ao visualizar DANFE, tente novamente mais tarde.', {});

    }

    this.obs.buscando = false;
  }

  async load(): Promise<void> {
    if (this.obs.loaded) return;

    try {

      let resp_status = await api.get("/api/historico-notas-status");

      this.obs.hora = resp_status.data.hora;
      this.obs.confirmadas = resp_status.data.confirmadas;
      this.obs.nao_realizadas = resp_status.data.nao_realizadas;
      this.obs.desconhecidas = resp_status.data.desconhecidas;
      this.obs.ciencia = resp_status.data.ciencia;

      let resp_erros = await api.get("/api/historico-notas-status-erros");

      this.obs.totalErros = parseInt(resp_erros.data.total_auto);

    } catch (ex) {

      toast.error(`Erro ao buscar historico notas total de erros, tente novamente mais tarde.`, {});

    }

  }

  @action
  async download_post(documento: any): Promise<void> {
    try {
      let resp = await api.post("/download-nota", documento);

      runInAction(() => {
        if (resp.data != "erro") {
          const str = String(resp.data.ret);
          const res = str.split(",", 3);
          this.obs.InfoDownload1 = res[0];
          this.obs.InfoDownload2 = res[1];
          this.obs.InfoDownload3 = res[2];
          let file = resp.data.filename;

          if (file == "Erro") {
            this.obs.progressDownload = false;
            NFesStore.obs.progressDownload = false;
            toast.error('Não foi possível realizar o download.', {});
          } else {
            let url = `/download-file?file=${file}`;
            window.location.href = url;
            this.obs.progressDownload = false;
            NFesStore.obs.progressDownload = false;
            this.obs.InfoDownload = true;
          }
        } else {
          toast.error('Não foi possível realizar o download.', {});
          this.obs.progressDownload = false;
          NFesStore.obs.progressDownload = false;
        }
      });
    } catch (ex) {
      toast.error(`Erro ao realizar Download Nota, tente novamente mais tarde.`, {});
    }
  }

  @action
  async download_danfe_post(ids: any): Promise<void> {
    try {
      let resp = await api.post("/api/danfe-download", ids);

      if (resp.data.ok) {
        this.obs.progressDownload = false;
        this.obs.InfoDownloadDanfe = true;

        const linkSource = `data:application/pdf;base64,${resp.data.base64}`
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = resp.data.filename;
        downloadLink.click();

      } else {

        this.obs.progressDownload = false;

        toast.error('Não foi possível realizar o download.', {});

      }

    } catch (ex) {

      toast.error(`Erro ao realizar Download Danfe, tente novamente mais tarde.`, {});

    }

  }

  @action
  async confirm_post(ids: any): Promise<void> {
    try {
      let resp = await api.post("/api/confirmar-operacao-list", ids);
      runInAction(() => {
        localStorage.setItem("Status", "NFe-s manifestadas com sucesso!");
        window.location.reload();
      });
    } catch (ex) {
      toast.error(`Erro ao Manifestar Nfe-s, tente novamente mais tarde.`, {});
    }
  }

  @action
  async desconhecer_post(ids: any): Promise<void> {
    try {
      let resp = await api.post("/api/desconhecer-operacao-list", ids);
      runInAction(() => {
        localStorage.setItem("Status", "NFe-s manifestadas com sucesso!");
        window.location.reload();
      });
    } catch (ex) {
      toast.error(`Erro ao Desconhecer NFe-s, tente novamente mais tarde.`, {});
    }
  }

  @action
  setCurrentPage(page: number) {
    this.obs.currentPage = page;
  }

  StatusSefaz() {
    return "ok";
  }

  @action
  setFilter(filter: string) {
    this.obs.filter = filter;
  }

  @action
  async setBusca(empresa: any, filtro: string, tipo: string, date1: string, date2: string) {
    this.handldeItensProcessando()

    try {

      let data = {
        empresa: empresa,
        filtro: filtro,
        tipo: tipo,
        data1: date1,
        data2: date2
      }

      const resp = await api.post("/api/post-busca-historico-importacoes", data)

      this.obs.imps = [];

      if (resp.data == "Conta não Encontrado") {

        toast.warning('Não foram encontrado registros.', {});

      } else if (resp.data.length <= 0) {

        toast.warning('Não foram encontrados resultados.', {});

      } else {

        this.obs.imps = [];

        this.obs.imps = resp.data

        this.obs.loaded = true;

      }

    } catch (ex) {

      toast.error(`Erro ao Buscar Manifestações, tente novamente mais tarde.`, {});

    }

  }

  async setBuscaDay() {
    var empresa = "Todas";
    var filtro = "Todos";
    var tipo = "NF-e";
    var date1 = moment().format("YYYY-MM-DD");
    var date2 = moment().format("YYYY-MM-DD");

    this.handldeItensProcessando()

    try {

      let data = {
        empresa: empresa,
        filtro: filtro,
        tipo: tipo,
        data1: date1,
        data2: date2
      }

      const resp = await api.post("/api/manifestacoes-dia", data)

      if (resp.data == "Conta não Encontrado") {

        toast.warning('Não foram encontrado registros.', {});

      } else if (resp.data.length <= 0) {

        toast.warning('Não há manifestações sincronizadas para hoje.', {});

      } else {

        this.obs.imps = [];

        this.obs.imps = resp.data

        this.obs.loaded = true;

      }

    } catch (e) { }

  }

  @action
  async handleGerarRelatorioExcel(
    empresa: string,
    date1: string,
    date2: string,
    filtro: string,
  ) {
    try {
      let data = { empresa: empresa, data1: date1, data2: date2, filtro: filtro };

      let resp = await api.post("/api/gerar-relatorio-excel", data);

      if (resp.data.ok) {
        const linkSource = `data:application/xlsx;base64,${resp.data.base64}`;
        const downloadLink = document.createElement("a");
        const fileName = "export-manifestacao.xlsx";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        toast.warning('Não foram encontrados resultados.', {});
      }
    } catch (ex) {
      toast.error(`Erro ao gerar Relatório Excel, tente novamente mais tarde.`, {});
    }
  }

  @action
  async handleGerarRelatorioPdf(
    empresa: string,
    date1: string,
    date2: string,
    filtro: string,
  ) {
    try {
      let data = { empresa: empresa, data1: date1, data2: date2, filtro: filtro };

      let resp = await api.post("/api/download-tabela-pdf", data);

      if (resp.data.ok) {
        const linkSource = `data:application/pdf;base64,${resp.data.base64}`;
        const downloadLink = document.createElement("a");
        const fileName = "manifestacao.pdf";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        toast.warning('Não foram encontrados resultados.', {});
      }
    } catch (ex) {
      toast.error(`Erro ao gerar Relatório Pdf, tente novamente mais tarde.`, {});
    }
  }


  @computed
  get filtered(): IHistoricoNotas[] {
    let ret = [];
    for (let imp of this.obs.imps) {
      let passesFilter = true;
      let filter = this.obs.filter.toUpperCase();

      if (filter) {
        passesFilter = imp.id != -1 ||
          imp.id != -1 ||
          imp.id != -1;
      }

      if (passesFilter) ret.push(imp);
    }
    return ret;
  }

  getPage(page: number, pageSize = 10000): IHistoricoNotas[] {
    let start = (page - 1) * pageSize;
    let end = start + pageSize;
    return this.filtered.slice(start, end);
  }

  getAllPages(page: number, pageSize = 10000): IHistoricoNotas[] {
    let start = (page - 1) * pageSize;
    let end = start + pageSize;
    return this.filtered.slice(start, end);
  }

  setCalcularItems(items: IManifestacaoCalc) {
    this.obs.calcularItems.push(items);
  }

  setCalcularItemsList(items: IManifestacaoCalc[]) {
    this.obs.calcularItems = items;
  }

  deleteByIdCalcularItems(id: string) {
    this.obs.calcularItems = this.obs.calcularItems.filter(value => value["id"] != id)
  }

  resetCalcularItems() {
    this.obs.calcularItems = [];
  }

  async create_manifestacao_task(cnpj_destino: string, dhemi_start: string, dhemi_end: string, ids: any, modelo: string, tipo: string) {

    let new_ids = ids?.map(values => {
      if (values.download) {
        return values.id
      }
    })
    var filter = new_ids.filter(function (x) {
      return x !== undefined;
    });

    let params = {
      "cnpj_destino": cnpj_destino,
      "dhemi_start": dhemi_start,
      "dhemi_end": dhemi_end,
      "ids": filter,
      "modelo": modelo.replace(/\-/g, "").toLowerCase(),
      "tipo": tipo.replace(/\-/g, "").toLowerCase(),
    }

    if (params.ids.length == 0) {
      toast.error('Somente Chaves com Download Disponível!', {});
      return
    }
    try {
      let resp = await api.post("/api/manifestacao/task/create", params);

      if (resp.data.ok) {
        toast.success('Contestação Cadastrada', {});
        ManifestacoesStore.obs.calcularItems = []
        await this.setBusca(cnpj_destino, "Todos", modelo, dhemi_start, dhemi_end)
        await this.handldeItensProcessando()

      } else {
        toast.error(resp.data.msg, {});
      }
    } catch (ex) {
      toast.error(`Erro ao criar Task Manifestação, tente novamente mais tarde.`, {});
    }
  }

  async handleConsultaTodas(paged: number, limit: number) {
    try {
      let data = {
        page: paged,
        limit: limit
      }
      let resp = await api.post("/api/manifestacao/task/index", data);

      this.obs.tasks_manifestacoes = [];
      this.obs.length_tasks_manifestacoes = 0

      if (resp.data.itens.length > 0) {
        this.obs.tasks_manifestacoes = resp.data.itens;
        this.obs.length_tasks_manifestacoes = resp.data.count
      }

    } catch (ex) {
      toast.error(`Erro ao consultar Tasks Manifestação, tente novamente mais tarde.`, {});
    }
  }

  async handldeItensProcessando() {
    try {
      this.obs.itens_calculando = []

      let resp = await api.get("/api/manifestacao/task/pendentes");

      this.obs.itens_calculando = resp.data.items

    } catch (ex) {
      toast.error(`Erro ao consultar Tasks pendentes Manifestação, tente novamente mais tarde.`, {});
    }
  }

  async summary_manifestacao(manifestacao_id: string, tipo: string, modelo: string) {
    try {
      this.obs.isValida = false;
      this.obs.manifestacoes_summary = newIImportInfo();

      let data = {
        importacao_id: manifestacao_id,
        tipo: tipo,
        modelo: modelo
      }

      let resp = await api.post(`/api/import/summary`, data);

      runInAction(() => {
        if (Array.isArray(resp.data)) {
          this.obs.isValida = true
        } else {
          this.obs.isValida = false;
          this.obs.manifestacoes_summary = resp.data
        }
      });
    } catch (ex) {
      toast.error(`Erro ao carregar Task Summary Manifestação, tente novamente mais tarde.`, {});
    }
  }

  async busca_erros_manifestacoes(page, manifestacao_id) {
    try {
      this.obs.erros_manifestacoes = []

      let data = { page: page, limit: 15, importacao_id: manifestacao_id }

      let resp = await api.post(`/api/import/erros`, data);

      runInAction(() => {
        if (resp.data.length > 0) {
          resp.data?.map(values => {
            values.itens?.map(erros => {
              this.obs.erros_manifestacoes.push(erros);
            })
          })
        } else {
          this.obs.erros_manifestacoes = []
        }
      });
    } catch (ex) {
      toast.error(`Erro ao carregar Task Erros Manifestação, tente novamente mais tarde.`, {});
    }
  }

  async busca_avisos_manifestacoes(page, manifestacao_id) {
    try {
      let data = { page: page, limit: 15, importacao_id: manifestacao_id }

      let resp = await api.post(`/api/import/avisos`, data);

      runInAction(() => {
        if (resp.data.length > 0) {
          resp.data?.map(values => {
            values.itens?.map(avisos => {
              this.obs.avisos_manifestacoes.push(avisos);
            })
          })
        }
      });
    } catch (ex) {
      toast.error(`Erro ao carregar Task Avisos Manifestação, tente novamente mais tarde.`, {});
    }
  }
}

export const ManifestacoesStore = new _ManifestacoesStore();
